import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import { Typography } from "@mui/material";
import {
  StyledTabContainer,
  StyledIndividualTab,
} from "../../Components/CustomTab";
import { useSelector } from "react-redux";
export default function TabWithColorDiagnostics(props) {

  const value = useSelector((state)=>state.DiagnosticsTabValue.value)

  const handleChange = (event, newValue) => {
    // setValue(newValue);
    props.ChangeTheTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <StyledTabContainer
        value={value}
        onChange={handleChange}
        aria-label="styled tabs example"
        elevation={1}
        myColor={ThemeProperties.purple}
      >
        {props.tabs.map((item, index) => (
          <StyledIndividualTab
            key={index}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="specificTabBold">{item.name}</Typography>
              </div>
            }
            myColor={ThemeProperties.purple}
          />
        ))}
      </StyledTabContainer>
    </Box>
  );
}
